var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-table"},[(_vm.showHeader)?_c('div',{staticClass:"header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"body"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }